import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ToastService } from "./toast.service";
import { map, catchError } from "rxjs/operators";
import { Observable } from "rxjs";
@Injectable()
export class PlaceService {
  private base_url = `${environment.API_URL}/places`;
  private single_url = `${environment.API_URL}/place`;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);

  constructor(private http: HttpClient, private toast: ToastService) {}

  getCities(params) {
    //params["token"] = this.token
    return this.http
      .post(`${this.base_url}/cities`, params, { headers: this.headers })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  getCity(city_id) {
    return (
      this.http
        //.get(`${this.single_url}/${city_id}?token=${this.token}`)
        .get(`${this.single_url}/${city_id}`, { headers: this.headers })
        .map((res) => JSON.parse(JSON.stringify(res)))
    );
  }

  createCity(params): Observable<any> {
    //params["token"] = this.token;
    return this.http
      .post(this.single_url, params, { headers: this.headers }).pipe(
        map((res) => {
          let response = JSON.parse(JSON.stringify(res));

          this.toast.success("Ville Ajoutée avec succès.", false, "Ville");
          return response;
        }),
        catchError(error => {
          console.log(error);
          this.toast.error(error.error.message, false, "Erreur");
          return new Observable(observer => {
            observer.error(error);
          })
        })
      )
      /*.map((res) => {
        console.log(res);
        let response = JSON.parse(JSON.stringify(res));
        if (response.error) {
          this.toast.error(response.error, false, "Ville");
        } else if (response.id) {
          this.toast.success("Ville Ajoutée avec succès.", false, "Ville");
        } else {
          this.toast.error("Erreur lors de l'ajout de la ville.", false, "Ville");
        }
        return response;
      });*/
  }

  autocompleteCities(query) {
    let params = {
      token: this.token,
      query: query,
    };
    return this.http
      .post(`${this.base_url}/city/autocomplete`, params, {
        headers: this.headers,
      })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  autocompleteAreas(query) {
    let params = {
      token: this.token,
      query: query,
    };
    return this.http
      .post(`${this.base_url}/area/autocomplete`, params, {
        headers: this.headers,
      })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }

  autocompleteCountries(query) {
    let params = {
      token: this.token,
      query: query,
    };
    return this.http
      .post(`${this.base_url}/country/autocomplete`, params, {
        headers: this.headers,
      })
      .map((res) => JSON.parse(JSON.stringify(res)));
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/place.service.ts